.app {
  width: 100%;
}

.bookingRestrictionsList {
  width: 100%;

  td,
  th {
    padding: 0.5rem;
  }
}

.dataTableContainer {
  margin-top: 1rem;
}
